module.exports = __webpack_public_path__ + "static/media/github.af0091ca.svg";